<template>
    <transition name="modal-fade">
        <div class="modal-background">
            <div class="modal-container">
                <div class="modal-header">
                    <h1>{{title}}</h1>
                    <button
                        type="button"
                        class="btn-close"
                        @click="close"><img src="../../images/x.svg">
                    </button>
                </div>
                <div class="modal-body">
                    <slot name="body"></slot>
                </div>
                <div class="modal-footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'modal-helper',
    props: ['title'],
    methods: {
        close() {
            this.$emit('close');
        },
    },
};
</script>

<style scoped>
  .modal-background {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
  }
  .modal-container {
      background: #ffffff;
      box-shadow: 2px 2px 20px 1px;
      overflow-x: auto;
      display: flex;
      flex-direction: column;
      min-width: 800px;
      border-radius: 4px;
  }
  .modal-header,
  .modal-footer,
  .modal-body {
      padding: 15px;
  }
  .modal-header {
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      width: 100%;
  }
  .modal-footer {
      border-top: 1px solid #eeeeee;
  }
  .modal-body {
      max-height: 400px;
      overflow-y: auto;
      position: relative;
  }
  .btn-close {
      border: none;
      font-size: 20px;
      cursor: pointer;
      font-weight: bold;
      background: transparent;
  }
  .modal-fade-enter,
  .modal-fade-leave-active {
      opacity: 0;
      transform: translateY(10px);
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
      transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
</style>